import React from "react";
import CustomModal from "../../../components/common/general/CustomModal/CustomModal";
import DeleteJourney from "../../../components/journey/DeleteJourney/DeleteJourney";

const DeleteJourneyModalContainer = ({ visible, onClose, onDelete }) => {
  return (
    <CustomModal visible={visible} onRequestClose={onClose} showCloseButton={true} title="Delete Journey">
      <DeleteJourney deleteButtonClick={onDelete} backButtonClick={onClose} />
    </CustomModal>
  );
};

export default DeleteJourneyModalContainer;
